<template>
  <v-card
    :flat="flat"
    :tile="tile"
    :outlined="outlined"
    :loading="loading"
    :loader-height="loaderHeight"
    :dark="dark"
    :hover="hover"
    :disabled="disabled"
    :class="[
      'asc-card',
      noSpacing ? 'asc-card--noSpacing' : '',
      flat ? 'asc-card--flat' : '',
      outlined ? 'asc-card--outlined' : '',
      dark ? 'asc-card--dark' : '',
      hover ? 'asc-card--hover' : '',
    ]"
  >
    <v-card-title v-if="hasTitleSlot" class="asc-card__title">
      <div>
        <slot name="title"></slot>
      </div>
    </v-card-title>
    <v-card-text
      :class="['asc-card__text', !hasTitleSlot ? 'asc-card__text-cover' : '']"
    >
      <slot></slot>
    </v-card-text>
  </v-card>
</template>

<script>
export default {
  name: 'AscCard',

  props: {
    dark: {
      type: Boolean,
      default: false,
    },
    flat: {
      type: Boolean,
      default: false,
    },
    tile: {
      type: Boolean,
      default: true,
    },
    noSpacing: {
      type: Boolean,
      default: false,
    },
    outlined: {
      type: Boolean,
      default: false,
    },
    loading: {
      type: Boolean,
      default: false,
    },
    loaderHeight: {
      type: Number,
      default: 2,
    },
    hover: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },

  computed: {
    hasTitleSlot() {
      return !!this.$slots.title
    },
  },
}
</script>

<style lang="scss">
.asc-card {
  box-shadow: 0 1px 4px 0 rgba(0, 0, 0, 0.3) !important;

  &__title {
    font-size: $font-size-md;
    color: $primary-black;
    line-height: 18px;
    letter-spacing: 1px;
    text-transform: uppercase;
    font-weight: 500;

    > div {
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }
  }

  &__text {
    font-size: 14px;
    color: $primary-black !important;
    line-height: 18px;
    letter-spacing: 0;
  }

  &--dark {
    background-color: $gray-200 !important;
  }

  &--noSpacing {
    padding: 0;

    .asc-card__title {
      padding: 0;
    }

    .asc-card__text {
      padding: 0;
    }
  }

  &--flat {
    box-shadow: none !important;

    &.asc-card--hover {
      cursor: pointer;

      &:hover,
      &:focus {
        box-shadow: 0 1px 4px 0 rgba(0, 0, 0, 0.3) !important;
        transition: box-shadow 0.4s cubic-bezier(0.25, 0.8, 0.25, 1);
      }
    }
  }
}
</style>
